import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { HeaderSection } from "../HeaderSection";
import { Model } from "../Model";
import { Title } from "../Title";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import styled from "styled-components";
import Calendar from "../../../organisms/Calendar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Resumen from "../Resumen/Resumen";
import SuccessButton from "../../../organisms/SuccessButton";
import { useWizard } from "../../../../hooks/wizard";
import Tarifas from "../Tarifas/Tarifas";

function Fechas({ model }: { model: Model }) {
  const [currentModel, setCurrentModel] = useState(model);
  const { avanza, vuelve, volver, avanzar } = useWizard();

  const puedeAvanzar = currentModel.fechasProgramadas.length > 0;

  const onDateClick = (date: Date) => {
    let fechas = currentModel.fechasProgramadas;
    const exists = fechas.some((f) => f.getTime() === date.getTime());

    let fechasActualizadas: Date[] = [];

    if (exists) {
      fechasActualizadas = fechas.filter((f) => f.getTime() !== date.getTime());
    } else {
      fechasActualizadas = [...fechas, date];
    }

    setCurrentModel((prevModel) => {
      return {
        ...prevModel,
        fechasProgramadas: fechasActualizadas,
      };
    });
  };

  if (avanza) {
    return <Resumen model={currentModel} />;
  }

  if (vuelve) {
    return <Tarifas model={currentModel} />;
  }

  return (
    <Row className="justify-content-center">
      <Col className="col-10">
        <HeaderSection className="pt-2 pb-2">
          <Title>
            Fechas de reserva
            <IconContainer>
              <CalendarMonthIcon sx={{ fontSize: 28 }} />
            </IconContainer>
          </Title>
        </HeaderSection>
        <Row className="mb-3">
          <label className="mb-2">Elija fechas de agendamiento:</label>
          <Col
            className="col-12"
            style={{ paddingRight: "0", paddingLeft: "0" }}
          >
            <StyledCalendar onDateClick={onDateClick} />
          </Col>
        </Row>

        <Row className="mb-2 justify-content-between">
          <Button
            type={"button"}
            style={{ width: "fit-content" }}
            onClick={volver}
          >
            <ArrowBackIcon sx={{ fontSize: 20 }} />
            Volver
          </Button>
          <SuccessButton
            type={"button"}
            style={{ width: "fit-content" }}
            disabled={!puedeAvanzar}
            onClick={avanzar}
          >
            Siguiente <ArrowForwardIcon sx={{ fontSize: 20 }} />
          </SuccessButton>
        </Row>
      </Col>
    </Row>
  );
}

const IconContainer = styled("span")`
  display: relative;
  margin-left: 8px;
  color: ${(props) => props.theme.colors.main};
`;

const StyledCalendar = styled(Calendar)`
  width: 100%;
  border-radius: 5px;
  padding: 0%;
`;

export default Fechas;
